<template>
  <div id="additionalServices" class="networkshops-additional-services">
    <div>
      <h2 class="vz-text-align-left">{{ data.title }}</h2>
      <ul class="public-list public-list-square ml-10">
        <li v-for="text in data.list.split(';')">
          <span>{{ text }}</span>
        </li>
      </ul>
    </div>
    <div class="networkshops-additional-services-card shipping-types-banner-link">
      <div class="flex">
        <vz-icon
          url="/svg/vz-cup.svg"
          size="56"
          variant="white"
          no-masked-icon
          class="mr-15 mb-20 flex-align-items-start"
        />
        <client-only>
          <div class="shipping-types-banner-link-title vz-text-align-left">
            {{ cardText }}
          </div>
        </client-only>
      </div>
      <vz-button large href="#" variant="public-primary" @click.prevent="$showDialog({ name: 'feedback-message' })" class="mx-auto">
        Коммерческое предложение
      </vz-button>
    </div>
    <vz-feedback-message-modal
      department-code="tradingNetworksRelationsDep"
    />
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';
import VzIcon from '~/components/ui-kit/vz-icon.vue';
import VzFeedbackMessageModal from '~/components/modals/vz-feedback-message-modal.vue';

const props = defineProps({
  isMarketplaces: {
    type: Boolean,
    default: false
  }
})

const data = (await getPageContent('/networkshops')).blocks?.additionalServices

const cardText = computed(() => {
  return `${data.cardText} ${props.isMarketplaces ? ' заказов' : ' груза'} с  Vozovoz`
})
</script>

<style scoped lang="scss">
.networkshops-additional-services {
  margin-bottom: 110px;
  display: flex;
  gap: 90px;
  justify-content: space-between;
  align-items: flex-start;

  &-card {
    min-width: 400px;
    font-size: 24px;
    color: $pure-white;
  }

  @media screen and (max-width: $pub-md) {
    margin-bottom: 70px;
    &-card {
      min-width: 240px;
      font-size: 20px;
      > div {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }

  @media screen and (max-width: $pub-xs) {
    flex-direction: column-reverse;
    margin-bottom: 40px;
    &-card {
      min-width: 100%;
      > div {
        flex-direction: row;
      }
    }
  }
}
</style>
